
import { Component, Vue, Prop } from 'vue-property-decorator'
import { batchUnfreezeOrder } from '@/api/task/withdraw'
import { bulkChanges } from '@/utils/rules'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import PicsUploader from '@/components/PicsUploader/index.vue'

@Component({
  name: 'approval',
  components: {
    PicsUploader
  }
})
export default class extends Vue {
  @Prop({ required: true }) private infoList!: any[]
  @Prop({ required: true }) private ordernumbers!: any[]

  get language () {
    return AppModule.language
  }

  private statusList: any[] = []
  private setForm: any = {
    status: null,
    remarks: '',
    description: '',
    google_code: ''
  }
  private rules = bulkChanges
  private loading: boolean = false
  private show: boolean = false

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private changeStatus (i) {
    if (i === 1) {
      this.show = true
    } else {
      this.show = false
    }
  }

  // 上传图片
  private getPicList (fileList: any) {
    this.setForm.attach = fileList.map((item: any) => {
      return item.response.file_path
    })
  }

  private back () {
    this.setForm = {
      product: null,
      product_account: null,
      google_code: ''
    }
    this.$emit('close')
  }

  private async modifyOrderStatusBulk () {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        let { status, attach, google_code, description, remarks } = this.setForm
        const data: any = {
          ordernumbers: this.ordernumbers,
          status,
          attach,
          google_code,
          description,
          remarks
        }
        try {
          await batchUnfreezeOrder(data).then(() => {
            if (this.language === 'en') {
              this.$message({
                message: 'Approval successfully!',
                type: 'success'
              })
            } else if (this.language === 'zh_cn') {
              this.$message({
                message: '修改成功!',
                type: 'success'
              })
            } else if (this.language === 'zh_tw') {
              this.$message({
                message: '修改成功!',
                type: 'success'
              })
            }
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  private selProduct () {
    this.setForm.product_account = null
  }

  created () {}
}
